import { render } from "./AntivirusMobile.vue?vue&type=template&id=137d15be&scoped=true"
import script from "./AntivirusMobile.vue?vue&type=script&lang=js"
export * from "./AntivirusMobile.vue?vue&type=script&lang=js"

import "./AntivirusMobile.vue?vue&type=style&index=0&id=137d15be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-137d15be"

export default script